import { useToast } from '@/hooks/use-toast';
import { Toast, ToastContainer } from '@/components/composites/Toast';

/**
 * Toaster - Renders toast notifications from useToast hook
 *
 * This bridges the shadcn/ui-style useToast hook with the v7 Toast component.
 * Add this to App.tsx to enable toast notifications throughout the app.
 */
export function Toaster() {
  const { toasts, dismiss } = useToast();

  // Map shadcn variant names to v7 variant names
  const mapVariant = (variant?: string): 'success' | 'error' | 'warning' | 'info' => {
    switch (variant) {
      case 'destructive':
        return 'error';
      case 'success':
        return 'success';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  };

  // Get auto-dismiss duration based on variant (per UX spec)
  const getDuration = (variant?: string): number => {
    switch (variant) {
      case 'destructive':
        return 0; // Errors persist until dismissed
      case 'success':
        return 5000; // 5s for success
      default:
        return 3000; // 3s for info
    }
  };

  return (
    <ToastContainer>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          variant={mapVariant(toast.variant)}
          title={typeof toast.title === 'string' ? toast.title : undefined}
          description={typeof toast.description === 'string' ? toast.description : undefined}
          open={toast.open}
          onClose={() => dismiss(toast.id)}
          duration={getDuration(toast.variant)}
          action={toast.action}
        />
      ))}
    </ToastContainer>
  );
}

export default Toaster;
